import { gql } from 'apollo-boost';

export const UNLINK_SLACK_ACCOUNT = gql`
    mutation UnlinkSlackAccount($data: UnlinkSlackAccountInput!) {
        unlinkSlackAccount(data: $data) {
            id
            integrations {
                slack {
                    slackUserId
                    teamId
                    username
                    workspaceName
                    displayName
                    connectedAt
                }
            }
        }
    }
`;
